/* eslint no-use-before-define: [1, 'nofunc'] */

// Functions are hoisted, so in this case it's ok to override
// eslint since one function needs to reference the other

function nullifyEmptyStringsInObject(obj) {
  // Handle null and undefined values
  if (obj) {
    const keys = Object.keys(obj);
    const newObj = {};
    // Iterate through keys and recursively nullify empty strings
    keys.map((key) => {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          newObj[key] = nullifyEmptyStringsInArray(obj[key]);
        } else if (typeof obj[key] === 'object') {
          newObj[key] = nullifyEmptyStringsInObject(obj[key]);
        } else if (typeof obj[key] === 'string') {
          newObj[key] = obj[key] === '' ? null : obj[key];
        } else {
          newObj[key] = obj[key];
        }
      }
      return key;
    });
    return newObj;
  }
  return obj;
}

function nullifyEmptyStringsInArray(arr) {
  // Check for null or undefined values
  if (arr) {
    const newArr = [];
    // Iterate through array and recursively nullify strings
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        newArr.push(nullifyEmptyStringsInArray(arr[i]));
      } else if (typeof arr[i] === 'object') {
        newArr.push(nullifyEmptyStringsInObject(arr[i]));
      } else if (typeof arr[i] === 'string') {
        newArr.push(arr[i] === '' ? null : arr[i]);
      } else {
        newArr.push(arr[i]);
      }
    }
    return newArr;
  }
  return arr;
}

export default nullifyEmptyStringsInObject;



// WEBPACK FOOTER //
// ./webpack/lib/utils/nullifyEmptyStrings.js